import log from 'loglevel'
import axios from 'axios'

/* eslint class-methods-use-this: ["off"] */

export default class Organs {
  constructor() {
    log.info('[INFO] Initialize Organs Module')

    this.axios = axios.create({
      baseURL: 'https://pncp.gov.br/api/',
      timeout: 10000,
    })

    this.axios.defaults.headers.common.Authorization = ''
  }

  fetchOrgans() {
    const parameters = {
      params: {
        pagina: 1,
        tam_pagina: 10,
        q: '',
        tipos_documento: 'edital',
        ordenacao: '-data',
        status: 'recebendo_proposta',
      },
    }

    return new Promise((resolve, reject) => {
      this.axios
        .get('search/', parameters)
        .then(response => {
          log.debug('[DEBUG] Success to organs from pncp')
          resolve(response.data.filters.orgaos)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch organs from pncp')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
